// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__yc170","navigation":"layout_navigation__FYDa9","content":"layout_content__6Rk3+"};